import { fg } from '@atlaskit/platform-feature-flags/fg';

/** Text shown for a skill outside its details page. */
export const resolveSkillDisplayDescription = (helpText: unknown, description: unknown): string => {
	const availableHelpText = typeof helpText === 'string' && helpText.trim() ? helpText : '';
	if (fg('chat_skill_helptext_enabled') && availableHelpText) {
		return availableHelpText;
	}
	const availableDescription = typeof description === 'string' ? description : '';
	return availableDescription || availableHelpText;
};
